import { render, staticRenderFns } from "./goods-comments.vue?vue&type=template&id=1ac7b9bc&"
import script from "./goods-comments.vue?vue&type=script&lang=js&"
export * from "./goods-comments.vue?vue&type=script&lang=js&"
import style0 from "./goods-comments.vue?vue&type=style&index=0&lang=stylus&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports